import React, { useCallback, useState } from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { useSnackbar } from 'baseui/snackbar';
import { ACTION_BY } from '../../../../common/constant/constant';
import type { DeleteAnnotationsPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import { LONG_TOAST_DURATION, SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
type DeleteModalPropsT = {
  isOpen: false;
} | {
  isOpen: true;
  label: string;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
};
export function useDeleteHandler() {
  const dispatch = useDispatch();
  const {
    sendEventForDeleteAnnotations
  } = useAnalyticsForSidePanel();
  const {
    enqueue
  } = useSnackbar();
  const [deleteModalProps, setDeleteModalProps] = useState<DeleteModalPropsT>({
    isOpen: false
  });
  const handleDeleteModalCancel = () => {
    setDeleteModalProps({
      isOpen: false
    });
  };
  const handleDeleteAllAnnotations = useCallback((label: string) => {
    const handleConfirm = async () => {
      await dispatch({
        type: SIDE_PANEL_ACTIONS.DELETE_ANNOTATIONS,
        annotationLabels: [label]
      });
      setDeleteModalProps({
        isOpen: false
      });
      const eventPayload: DeleteAnnotationsPayloadT = {
        objectType: SIDE_PANEL_ACTIONS.DELETE_ANNOTATIONS,
        label: label,
        actionBy: ACTION_BY.EDIT
      };
      sendEventForDeleteAnnotations(eventPayload);
      enqueue({
        message: `All annotations labeled ${label} have been deleted.`,
        startEnhancer: () => React.createElement(TrashCan, {
          title: 'Deleted'
        })
      }, LONG_TOAST_DURATION);
    };
    setDeleteModalProps({
      isOpen: true,
      label,
      onCancel: handleDeleteModalCancel,
      onConfirm: handleConfirm
    });
  }, [dispatch, sendEventForDeleteAnnotations, enqueue]);
  return {
    handleDeleteAllAnnotations,
    deleteModalProps
  };
}